module.exports = __webpack_public_path__ + "static/delia.84177415.png";


//////////////////
// WEBPACK FOOTER
// ./src/bios/img/delia.png
// module id = 232
// module chunks = 35783957827783 107818501498521